import React, { Component } from 'react';
import ModalInvoicePayment from './ModalInvoicePayment';
import ModalInvoiceView from './ModalInvoiceView';
import { inject } from 'mobx-react';

@inject('userStore')
class InvoiceTableRow extends Component {
    constructor(props){
        super(props);
        this.state = {
            starred:false
        }
        this.onClick = this.onClick.bind(this);
        this.proposalHandler = this.proposalHandler.bind(this);
        this.qvHandler = this.qvHandler.bind(this);
        this.cbHandlerClick = this.cbHandlerClick.bind(this);
    }

    cbHandlerClick(event){
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
          [name]: value
        });
    }

    qvHandler(invoice){
        this.props.qHandler(invoice);
    }

    onClick(event, component, title){
        event.preventDefault();
        this.props.handler(this.props.inquiry, component, title);
    }

    proposalHandler(event){
        event.preventDefault()
        this.props.proposalHandler(this.props.inquiry)
    }


  render() {
      var dt_class = 'avatar bg-success';
      const {invoice, handler, sendHandler, publishHandler, invoiceHandler} = this.props;
      let days_since = invoice.days_since;
      if (!invoice.is_paid){
          if (days_since > 14){
              dt_class = 'avatar bg-danger';
          } else if (days_since > 7) {
              dt_class = 'avatar bg-warning';
          }
      } else {
          days_since = 'PAID';
      }
    return (
            <tr className="media align-items-center pt-0 cursor-pointer">
              <td style={{width:3+"%"}}>
                  <label className="toggler fs-16 pl-12 d-none d-md-block">
                    <input type="checkbox" name="starred" checked={this.state.starred} onChange={this.cbHandlerClick}/>
                    <i className="fa fa-star"></i>
                  </label>
              </td>
              <td style={{width:45+"%"}} onClick={() => this.qvHandler(invoice)}>
                  <a className="flexbox align-items-center flex-grow gap-items mt-20">
                    <div className="media-body text-truncate">
                      <h6>{invoice.description}</h6>
                      <small>
                        <span>{invoice.booking.event_name}</span>
                        <span className="divider-dash">{invoice.booking.full_name}</span>
                      </small>
                    </div>
                </a>
              </td>
              <td style={{width:27+"%"}} className="media">
                <span className={dt_class}>{days_since}</span>
                <div className="media-body text-truncate">
                  <h6 className="mb-0">{invoice.is_published ? <React.Fragment>Published: {invoice.publish_date}</React.Fragment> : <React.Fragment>Unpublished</React.Fragment>}</h6>
                  <small>
                    <span>Created on: {invoice.create_date}</span>
                  </small>
                </div>
              </td>
              <td style={{width:24+"%"}}>
                <span className="lead text-fade mr-25 d-none d-md-block pull-right" title="Service Total" data-provide="tooltip">${invoice.due_amount}</span>
              </td>
              <td style={{width:1+"%"}}>
                  <div className="dropdown">
                    <a className="text-lighter" data-toggle="dropdown"><i className="ti-more-alt rotate-90"></i></a>
                    <div className="dropdown-menu dropdown-menu-right">
                        <a className="dropdown-item" onClick={()=>handler(invoice, ModalInvoiceView, 'View Invoice')}><i className="fa fa-newspaper-o"></i> View</a>
                        <a className="dropdown-item"><i className="fa fa-print"></i> Print</a>
                        {invoice.is_published ?
                        <React.Fragment>
                            <a className="dropdown-item" onClick={()=>sendHandler(invoice)}><i className="fa fa-envelope"></i> Send Reminder</a>
                            <a className="dropdown-item" onClick={()=>handler(invoice, ModalInvoicePayment, 'Record Payment')}><i className="fa fa-money"></i> Record Payment</a>
                        </React.Fragment>
                        :
                        <React.Fragment>
                            <a className="dropdown-item" onClick={()=>invoiceHandler(invoice)}><i className="fa fa-pencil"></i> Edit</a>
                            <a className="dropdown-item" onClick={()=>publishHandler(invoice)}><i className="fa fa-external-link-square"></i> Publish</a>
                        </React.Fragment>
                        }
                    </div>
                  </div>
              </td>
             </tr>
        );
    }
}

export default InvoiceTableRow;



// WEBPACK FOOTER //
// ./src/components/business/InvoiceTableRow.js